import React from "react";
import brand from "../content/brand";

const Pillars = () => (
  <div className="pillars">
    {brand.proofPoints.map((p, i) => (
      <div key={i} className="pillar">
        <div className="lbl">PRINCIPLE / {String(i + 1).padStart(2, "0")}</div>
        <p>{p}</p>
      </div>
    ))}
  </div>
);

export default Pillars;
